import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment.development';
import { STORAGE_ENUM } from '../../../auth/enums/storage.enum';
import { AuthService } from '../../../auth/services/auth/auth.service';
import { SessionService } from '../../../auth/services/session/session.service';
import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';
import { DocumentInStorage } from '../../models/documents.model';

@Injectable({
  providedIn: 'root'
})
export class MipService {
  private _http = inject(HttpClient);
  private _authService = inject(AuthService);
  private _sessionService = inject(SessionService);
  private _localStorage = inject(LocalStorageService);

  private _baseUrl = `${environment.apiUrl}/administrative/customers`;

  getCalendarDocument(
    fromDate: string,
    toDate: string,
    CT: boolean = false,
    RP: boolean = false,
    // OR: boolean = false,
    RM: boolean = false,
    QO: boolean = false
  ): Observable<DocumentInStorage> {
    const token = this._localStorage.get(STORAGE_ENUM.TOKEN);
    const customerId = this._sessionService!.Customer.id;

    let documentUrl = `${this._baseUrl}/${customerId}/merge/`;

    const data = {
      fromTime: fromDate,
      toTime: toDate,
      certificate: CT,
      report: RP,
      referral: RM,
      quote: QO
    }

    return this._http.post<DocumentInStorage>(
      documentUrl,
      data,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );
  }
}
